import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'lib-new-version-available-modal',
  templateUrl: './new-version-available-modal.component.html',
  styleUrl: './new-version-available-modal.component.scss'
})
export class NewVersionAvailableModalComponent implements OnInit {
  isReloadButtonDisabled = true;

  constructor(public activeModal: NgbActiveModal) {}

  ngOnInit(): void {
    setTimeout(() => {
      this.isReloadButtonDisabled = false;
    }, 1500); // 1500 ms = 1.5 second
  }

  reload() {
    window.location.reload();
  }

  close() {
    this.activeModal.dismiss();
  }
}
